import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE = "/api/ticket_department_tags";

export default {
    // Etiquetas de Trackernet de un departamento: una por tipo de ticket y la genérica (sin ticketType)
    async getByDepartment(departmentIri) {
        return await Api()
            .get(RESOURCE, { params: { department: departmentIri } })
            .catch((err) => errorHandler(err, null));
    }
}
